import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Arquivo } from './arquivo.model';
import { firstValueFrom } from 'rxjs';
import { BaseService } from '../services/base-service.service';

@Injectable()
export class ArquivoService extends BaseService<Arquivo, number> {

  constructor(
    http: HttpClient
  ) {
    super('arquivo', http);
  }

  public exportarTextosEmArquivoZip(arquivoIds: number[]): Promise<Blob> {
    return firstValueFrom(this.http.post(this.path('exportarTextosEmArquivoZip'), arquivoIds, { headers: this.createJsonHttpHeaders(), responseType: 'blob' }));
  }
}
